// The output heat map of the Position Sizing tables (the sizing table and the
// two attribute tables): a translucent tint per level of
// utils/positionSizingOutputHeatmap.js, laid over the row's own background
// (stripe, hover or state tint). The accent colour for non-negative outputs,
// the positive and negative colours for signed ones, at the opacities the
// DataGrid styles used. Written out in full so Tailwind finds every class.
export const OUTPUT_HEATMAP_CLASS_NAMES = Object.freeze({
    sequential: Object.freeze([
        'bg-accent/[0.025]',
        'bg-accent/[0.035]',
        'bg-accent/[0.045]',
        'bg-accent/[0.06]',
        'bg-accent/[0.075]',
        'bg-accent/[0.09]',
        'bg-accent/[0.11]',
        'bg-accent/[0.13]',
    ]),
    positive: Object.freeze([
        'bg-positive/[0.025]',
        'bg-positive/[0.035]',
        'bg-positive/[0.045]',
        'bg-positive/[0.06]',
        'bg-positive/[0.075]',
        'bg-positive/[0.09]',
        'bg-positive/[0.11]',
        'bg-positive/[0.13]',
    ]),
    negative: Object.freeze([
        'bg-negative/[0.025]',
        'bg-negative/[0.035]',
        'bg-negative/[0.045]',
        'bg-negative/[0.06]',
        'bg-negative/[0.075]',
        'bg-negative/[0.09]',
        'bg-negative/[0.11]',
        'bg-negative/[0.13]',
    ]),
});

/**
 * The tint class of one output cell: `heatmap` from
 * buildPositionSizingOutputHeatmap, the column's field and the row's id.
 * Undefined when the cell has no level.
 */
export function outputHeatmapClassName(heatmap, field, rowId) {
    const entry = heatmap.get(field)?.get(rowId);
    return entry ? OUTPUT_HEATMAP_CLASS_NAMES[entry.tone][entry.level - 1] : undefined;
}
